export default "__VITE_ASSET__CAeyqF3z__"